import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { CoreModule } from './core/core.module';
import { YtNgFrameworkModule } from 'yt-ng-framework';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { ConvItems2Treeviewitem } from './core/classes/conv-items2-treeviewitem';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbPopoverModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './translate/', '.json'); // ili odgovarajuća putanja
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    CoreModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      timeOut: 2000
      // preventDuplicates: true,
      // closeButton: true
    })
    ,YtNgFrameworkModule.forRoot()
      ,  TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    //ConfigService
    //, BaseContainerService
    ConvItems2Treeviewitem,
    // {provide: ToastrService, useClass: FakeToastrService}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
